import { Trans, useTranslation } from 'react-i18next';
import { TakerMarket } from '@/enterprise/data/useTakerMarkets';
import NextMarketClearTimeCountdown from '@/enterprise/features/takerMarketTable/components/NextMarketClearTimeCountdown';
import { trimDateTimestamp } from '@/utils/trimDateTimestamp';

export const OfferReviewDetails = ({
  takerMarket,
  hasSetSchedule,
}: {
  takerMarket: TakerMarket;
  hasSetSchedule?: boolean;
}) => {
  const { t } = useTranslation();
  const paymentMessageString = t('offerSubmitDialog.paymentDepositMessage');
  const paymentMessageDate = takerMarket.marketGoodFundsDate;

  return (
    <ul className="ml-4 list-disc space-y-2">
      {hasSetSchedule ? (
        <>
          <li>
            <Trans
              i18nKey="offerSubmitDialog.scheduleParticipation"
              components={{
                style: <span className="font-semibold" />,
              }}
            />
          </li>
          <li>{t('offerSubmitDialog.scheduleManualAdjustment')}</li>
          {!!takerMarket.offerConfig.exclusionSettings.excludeNewInvoices && (
            <li>{t('offerSubmitDialog.scheduleExcludeFutureInvoicesToBeDisabled')}</li>
          )}
          <li>{t('offerSubmitDialog.steps.clearing')}</li>
          <li>{t('offerSubmitDialog.schedulePaymentInitiation')}</li>
          <li>{t('offerSubmitDialog.scheduleDisclaimer')}</li>
          <li>{t('scheduling.schedulesOperateUsCentral')}</li>
        </>
      ) : (
        <>
          <li>
            {t('offerSubmitDialog.marketClearMessage')}
            <span className="ml-1">
              <NextMarketClearTimeCountdown takerMarket={takerMarket} />
            </span>
          </li>
          <li>{`${paymentMessageString} ${
            paymentMessageDate ? trimDateTimestamp(paymentMessageDate) : t('core.na')
          }`}</li>
          <li>{t('offerSubmitDialog.steps.clearing')}</li>
          <li>{t('offerSubmitDialog.disclaimer')}</li>
        </>
      )}
    </ul>
  );
};
